// GridHeader Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class GridHeader extends Component {
  static get propTypes () {
    return {
      columns: PropTypes.array,
      showSelectAll: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      columns: '',
      showSelectAll: false
    }
  }

  render () {
    const { columns, showSelectAll } = this.props
    return (
      <div className='cgrid-header'>
        {showSelectAll && <div className='cgridcol cgridcol-select' />}
        {columns.map((column) => (
          <div
            className={classnames(
              'cgridcol',
              `cgridcol-${column.ident}`,
              column.className
            )}
            key={column.ident}
            style={column.style || {}}
          >
            <IntlMessage ident={column.title} />
          </div>
        ))}
      </div>
    )
  }
}

export default GridHeader
